// Как количество заданий по теме распределяется между её генераторами (3.2
// docs/homework-phase2-design.md).
//
// ⚠️ Файл лежит в КОРНЕВОМ экспорте, а не рядом с реестром, и это переезд, а не
// новое место: до 18.08.2026 функция жила в `generators/request.ts`, то есть за
// барьером ответов. Серверу этого хватало, предпросмотру состава в форме выдачи
// нет: `apps/web` не импортирует `@edu/shared/exercises/oge` ни одним путём
// (5.11 фазы 2), а показать преподавателю состав до нажатия надо той же
// функцией, которой сервер потом разложит задания. Две копии правила («по
// кругу» на сервере и «по кругу» в предпросмотре) разошлись бы первым же
// рефакторингом, и разошлись бы молча: экран показал бы один состав, ученик
// получил бы другой.
//
// Барьер переездом не задет: на вход идёт только `id`, то есть показываемая
// половина, ровно та, что уезжает клиенту справочником тем. Реестра функция не
// видит и никогда не видела.

/**
 * По кругу, в порядке реестра. Пять заданий на двух генераторах это три и два.
 *
 * Не случайный выбор генератора на каждое задание: пять бросков могут дать пять
 * раз один и тот же генератор, то есть пять почти одинаковых заданий, и
 * преподаватель узнает об этом от ученика.
 *
 * Принимает всё, у чего есть `id`: на сервере это `Generator` из реестра, в
 * форме выдачи `OgeGeneratorInfo` из справочника тем. Порядок входного массива
 * это часть контракта справочника, на нём держится честность предпросмотра.
 */
export function planPicks<T extends { readonly id: string }>(
  gens: readonly T[], count: number,
): readonly { readonly generator: string; readonly count: number }[] {
  if (gens.length === 0) return [];
  const per = gens.map(() => 0);
  for (let i = 0; i < count; i += 1) {
    const at = i % gens.length;
    per[at] = (per[at] ?? 0) + 1;
  }
  return gens
    .map((g, i) => ({ generator: g.id, count: per[i] ?? 0 }))
    .filter((p) => p.count > 0);
}
